import axios from '../../axios'

// 新增专业备注
export const addProfRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark',
        method: 'POST',
        data
    })
}

// 获取专业备注详情
export const getProfRemarkInfo = (data) => {
    return axios({
        url: '/api/data/wish/remark/info',
        method: 'GET',
        data
    })
}

// 编辑修改专业备注
export const editProfRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark',
        method: 'PUT',
        data
    })
}

// 删除专业备注
export const deleteProfRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark',
        method: 'DELETE',
        data
    })
}

// 综合搜索专业备注信息列表
export const searchProfRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark',
        method: 'GET',
        data
    })
}

// 专业备注导入功能
export const importProfRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark/import',
        method: 'POST',
        data
    })
}

// 专业备注导出功能
export const exportProfRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark/export',
        method: 'POST',
        data
    })
}

// 专业备注批量更新功能
export const updataProfRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark/batch/update',
        method: 'POST',
        data
    })
}

// 专业备注批量删除功能
export const queryDelProfRemark = (data) => {
    return axios({
        url: '/api/data/wish/remark/batch/delete',
        method: 'POST',
        data
    })
}

// 专业列表模糊查询
export const searchProfList = (data) => {
    return axios({
        url: '/api/data/wish/search/prof',
        method: 'GET',
        data
    })
}

// 专业列表查找
export const searchProfListBySchool = (data) => {
    return axios({
        url: '/api/data/wish/admission/school/prof',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/profremark.js